"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAIOutput = exports.convertAiFieldResult = exports.getPageSetFromConfig = exports.fieldConfigToAiConfig = exports.deserializeOutput = exports.serializeOutput = exports.deserializeParams = exports.serializeParams = exports.isAssetVerificationMessage = void 0;
const common_1 = require("@finley-technologies/common");
const isAssetVerificationMessage = (message) => {
    return (typeof message === 'object' &&
        typeof message.s3Bucket === 'string' &&
        typeof message.s3Path === 'string' &&
        typeof message.organizationId === 'string' &&
        typeof message.ingestId === 'string');
};
exports.isAssetVerificationMessage = isAssetVerificationMessage;
const serializeParams = (params) => {
    return JSON.stringify({
        buffer: common_1.finleyBuffer.toBase64(params.buffer),
        config: params.config,
        extension: params.extension,
    });
};
exports.serializeParams = serializeParams;
const deserializeParams = (params) => {
    const parsed = JSON.parse(params);
    return {
        buffer: common_1.finleyBuffer.fromBase64(parsed.buffer),
        config: parsed.config,
        extension: parsed.extension,
    };
};
exports.deserializeParams = deserializeParams;
const serializeOutput = (output) => {
    return JSON.stringify(output);
};
exports.serializeOutput = serializeOutput;
const deserializeOutput = (output) => {
    return JSON.parse(output);
};
exports.deserializeOutput = deserializeOutput;
const configTypeToFinleyAiType = (type) => {
    switch (type) {
        case 'string':
        case 'optionalString':
            return 'string';
        case 'float':
        case 'optionalFloat':
        case 'percentage':
        case 'optionalPercentage':
            return 'float';
        case 'integer':
        case 'optionalInteger':
            return 'integer';
        case 'boolean':
        case 'optionalBoolean':
            return 'boolean';
        // extract these as strings
        // and let sanitize convert to correct type
        case 'currency':
        case 'optionalCurrency':
        case 'date':
        case 'optionalDate':
        case 'dateTime':
        case 'optionalDateTime':
            return 'string';
        default:
            return (0, common_1.finleyAssertUnreachable)(type);
    }
};
const fieldConfigToAiConfig = (field) => {
    return {
        question: field.question,
        fieldName: field.field,
        type: configTypeToFinleyAiType(field.type),
    };
};
exports.fieldConfigToAiConfig = fieldConfigToAiConfig;
const getPageSetFromConfig = (config) => {
    const setOfPages = new Set();
    config.fields.forEach((field) => {
        field.pageNumbers.forEach((page) => setOfPages.add(page));
    });
    return Array.from(setOfPages);
};
exports.getPageSetFromConfig = getPageSetFromConfig;
const convertAiFieldResult = (aiResult) => {
    return {
        fieldName: aiResult.fieldName,
        value: aiResult.value === null ? null : String(aiResult.value),
        confidence: aiResult.confidence || 0,
        error: aiResult.error,
        pageNumber: aiResult.pageNumber || -1,
    };
};
exports.convertAiFieldResult = convertAiFieldResult;
const convertAIOutput = (aiOutput, config) => {
    if (aiOutput.success === false) {
        const answers = config.fields.map((field) => ({
            fieldName: field.field,
            value: null,
            confidence: 0,
            error: aiOutput.error,
            pageNumber: -1,
        }));
        return {
            answers,
        };
    }
    return {
        answers: aiOutput.jsonResult.map(exports.convertAiFieldResult),
    };
};
exports.convertAIOutput = convertAIOutput;
//# sourceMappingURL=assetExtractor.js.map